export default function Xbox() {
  return (
    <div
      className="ion-icon-xbox"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<g>
	<path class="st0" d="M126.8,248.3c39.7-58.6,77.9-92.8,77.9-92.8s-42.1-48.9-92.8-67.4l-3.3-0.8C61.7,128.4,32,188.7,32,256
		c0,50.7,16.9,97.5,45.2,135C77.2,386.6,77.8,320.7,126.8,248.3z"/>
	<path class="st0" d="M480,256c0-67.3-29.7-127.6-76.6-168.7l-3.2,0.9c-50.7,18.5-92.9,67.4-92.9,67.4s38.2,34.2,77.9,92.8
		c49,72.4,49.6,138.3,49.5,142.7C463.2,353.5,480,306.7,480,256z"/>
	<path class="st0" d="M201.2,80.9c29.3,13.1,54.6,34.6,54.6,34.6s25.5-21.4,54.8-34.6c36.8-16.5,64.9-11.3,72.3-9.5
		C346.8,46.6,303.1,32,256,32c-47.1,0-90.8,14.6-126.9,39.4C136.3,69.6,164.3,64.3,201.2,80.9z"/>
	<path class="st0" d="M358.7,292.9C312.4,236,255.8,199,255.8,199s-56.3,37-102.7,93.9c-39.8,48.9-54.6,84.8-62.6,107.8l-1.3,4.8
		c41,45.7,100.5,74.5,166.8,74.5c66.3,0,125.8-28.8,166.8-74.5l-1.4-4.8C413.4,377.7,398.5,341.8,358.7,292.9z"/>
</g>
</svg>
`,
      }}
    />
  )
}
